var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bl-client-session bg-slate-200" }, [
    _c("div", { staticClass: "bl-client-session-navigation-panel" }, [
      _vm.pageLoading
        ? _c(
            "div",
            {
              staticClass:
                "absolute z-20 w-full h-full -m-4 -mr-5 lg:-my-6 lg:-mx-3 rounded-3xl"
            },
            [
              _c("div", {
                staticClass:
                  "absolute w-full h-full bg-pure-white opacity-75 rounded-3xl"
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "bl-client-session-navigation",
          class: {
            "bl-client-session-navigation-active": _vm.selectedMenu === "draft"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.selectedMenu = "draft"
            }
          }
        },
        [
          _vm.selectedMenu === "draft"
            ? _c("BlTextSubtitle2", {
                staticClass: "flex-shrink-0",
                attrs: { text: "Draft" }
              })
            : _c("BlTextBody1", {
                staticClass: "flex-shrink-0",
                attrs: { text: "Draft" }
              }),
          _vm._v(" "),
          _vm.draftSessions
            ? _c("BlBubbleCount", {
                staticClass: "bl-client-session-navigation-count",
                attrs: {
                  type: _vm.selectedMenu === "session" ? "secondary" : "",
                  count: _vm.draftSessionsCount || 0
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedMenu === "draft"
            ? _c("div", { staticClass: "bl-client-session-navigation-border" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "bl-client-session-navigation",
          class: {
            "bl-client-session-navigation-active":
              _vm.selectedMenu === "session"
          },
          on: {
            click: function($event) {
              _vm.selectedMenu = "session"
            }
          }
        },
        [
          _vm.selectedMenu === "session"
            ? _c("BlTextSubtitle2", {
                staticClass: "flex-shrink-0",
                attrs: { text: "Past Sessions" }
              })
            : _c("BlTextBody1", {
                staticClass: "flex-shrink-0",
                attrs: { text: "Past Sessions" }
              }),
          _vm._v(" "),
          _c("BlBubbleCount", {
            staticClass: "bl-client-session-navigation-count",
            attrs: {
              type: _vm.selectedMenu !== "session" ? "secondary" : "",
              count: _vm.pastSessionsCount || 0
            }
          }),
          _vm._v(" "),
          _vm.selectedMenu === "session"
            ? _c("div", { staticClass: "bl-client-session-navigation-border" })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "bl-client-session-panel",
        style: _vm.selectedMenu === "session" ? "gap: 1.5rem" : ""
      },
      [
        _c("div", { staticClass: "bl-client-session-header" }, [
          _c(
            "div",
            { staticClass: "bl-client-session-header-name-container" },
            [
              _c(
                "div",
                { staticClass: "bl-client-session-header-name" },
                [
                  _c("BlTextTitle4", {
                    attrs: {
                      text:
                        _vm.selectedMenu === "draft" ? "Draft" : "Past Sessions"
                    }
                  }),
                  _vm._v(" "),
                  _vm.sessions && _vm.sessions.length
                    ? _c("BlBubbleCount", {
                        attrs: {
                          count:
                            _vm.selectedMenu === "draft"
                              ? _vm.draftSessionsCount || 0
                              : _vm.pastSessionsCount || 0
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "bl-client-session-header-description",
                attrs: {
                  text:
                    _vm.selectedMenu === "draft"
                      ? "The drafts feature allows you to efficiently plan and prepare for your upcoming therapy sessions."
                      : "Access the data from your past therapy sessions to gain insights and monitor progress."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.selectedMenu === "draft"
            ? _c(
                "div",
                { staticClass: "bl-client-session-header-action-container" },
                [
                  _c("BlInputButton", {
                    staticClass: "bl-client-session-header-action",
                    attrs: {
                      icon: "plus",
                      label: "Create draft",
                      loading: _vm.createLoading
                    },
                    on: { clicked: _vm.createNewSession }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedMenu === "session"
            ? _c(
                "div",
                { staticClass: "bl-client-session-header-filter-container" },
                [
                  _c(
                    "div",
                    [
                      _c("BlInputFilterAdvance", {
                        attrs: { bubbleCount: "", input: _vm.filterInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlInputSelect", {
                        attrs: { input: _vm.sessionSortInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.selectedMenu === "draft"
          ? _c(
              "div",
              {
                staticClass: "pb-4 overflow-x-auto scrollbar-lg",
                style: {
                  width: "calc(100vw - 3rem - 20rem - 1.5rem - 5rem - 0.5rem)"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex bg-slate-200 rounded-t",
                    attrs: { id: "session-draft-header" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex border-t border-l border-r border-slate-400 sticky left-0 z-10 rounded-tl bg-pure-white"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-4 py-3 flex-shrink-0 bg-slate-200 w-20 rounded-tl"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-700",
                              attrs: { text: "ID" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-4 py-3 flex flex-shrink-0 bg-slate-200 w-50"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-700",
                              attrs: { text: "Name" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Status" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-60"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Scheduled for" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pl-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Assigned therapist" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Number of targets" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ]
                ),
                _vm._v(" "),
                _vm.fetchSessionDraftLoading
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sticky left-0 h-100 w-full grid place-items-center flex-grow rounded-b border-l border-r border-b border-slate-400"
                      },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.draftSessions.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sticky left-0 h-100 w-full grid place-items-center flex-grow rounded-b border-l border-r border-b border-slate-400"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("BlTextBody1", {
                              attrs: {
                                text:
                                  "Currently, there are no session draft to display. Once you create a"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center gap-1 text-center"
                              },
                              [
                                _c("BlTextBody1", {
                                  attrs: {
                                    text: "new draft, it will appear here."
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "plain",
                                    dense: "",
                                    label: "Create a new draft."
                                  },
                                  on: { clicked: _vm.createNewSession }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.draftSessions, function(session, idx) {
                        return _c("SessionDraftItem", {
                          key: session.id,
                          attrs: {
                            session: session,
                            idx: idx,
                            isLast: idx + 1 === _vm.draftSessions.length
                          },
                          on: {
                            "after-commit": function($event) {
                              return _vm.refreshSessions("draft,ongoing")
                            }
                          }
                        })
                      }),
                      1
                    ),
                _vm._v(" "),
                _vm.draftSessionsCount > 25
                  ? _c("BlInputPagination", {
                      staticClass: "mt-4 sticky left-0 z-10",
                      attrs: {
                        page: _vm.page,
                        perPage: _vm.perPage,
                        total: _vm.draftSessionsCount
                      },
                      on: {
                        changed: _vm.onChangePageDraft,
                        "changed-per-page": _vm.onChangePerPageDraft
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedMenu === "session"
          ? _c(
              "div",
              {
                staticClass: "pb-4 overflow-x-auto scrollbar-lg",
                style: {
                  width: "calc(100vw - 3rem - 20rem - 1.5rem - 5rem - 0.5rem)"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex bg-slate-200 rounded-t",
                    attrs: { id: "session-past-header" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex border-t border-l border-r border-slate-400 sticky left-0 z-10 rounded-tl bg-pure-white"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-4 py-3 flex-shrink-0 bg-slate-200 w-20 rounded-tl"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-700",
                              attrs: { text: "ID" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-4 py-3 flex flex-shrink-0 bg-slate-200 w-50"
                          },
                          [
                            _c("BlTextSubtitle3", {
                              staticClass: "text-slate-700",
                              attrs: { text: "Name" }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Status" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-60"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Scheduled for" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-64"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Recorded at" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Duration" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Recorded by" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700",
                          attrs: { text: "Number of targets" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                ),
                _vm._v(" "),
                _vm.fetchSessionLoading
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sticky left-0 h-100 w-full grid place-items-center flex-grow rounded-b border-l border-r border-b border-slate-400"
                      },
                      [_c("div", { staticClass: "blum-loader" })]
                    )
                  : !_vm.pastSessions.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sticky left-0 h-100 w-full grid place-items-center flex-grow rounded-b border-l border-r border-b border-slate-400"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("BlTextBody1", {
                              attrs: {
                                text:
                                  "Currently, there are no past session to display. Once you finish a"
                              }
                            }),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("BlTextBody1", {
                              attrs: { text: "session, it will appear here." }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.pastSessions, function(session, idx) {
                        return _c("SessionPastItem", {
                          key: session.id,
                          attrs: {
                            session: session,
                            idx: idx,
                            isLast: idx + 1 === _vm.pastSessions.length
                          },
                          on: {
                            "after-commit": function($event) {
                              return _vm.refreshSessions("completed,cancelled")
                            }
                          }
                        })
                      }),
                      1
                    ),
                _vm._v(" "),
                _vm.pastSessionsCount > 25
                  ? _c("BlInputPagination", {
                      staticClass: "mt-4 sticky left-0 z-10",
                      attrs: {
                        page: _vm.page,
                        perPage: _vm.perPage,
                        total: _vm.pastSessionsCount
                      },
                      on: {
                        changed: _vm.onChangePagePast,
                        "changed-per-page": _vm.onChangePerPagePast
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex sticky right-0 bg-pure-white flex-grow" },
      [
        _c("div", {
          staticClass:
            "px-4 py-3 border-t border-r border-slate-400 flex-shrink-0 bg-slate-200 w-60 rounded-tr flex-grow"
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex sticky right-0 bg-pure-white flex-grow" },
      [
        _c("div", {
          staticClass:
            "px-4 py-3 border-t border-r border-slate-400 flex-shrink-0 bg-slate-200 w-40 rounded-tr flex-grow"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f245af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f245af8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/ClientSession.vue
// module id = null
// module chunks = 